import React from 'react';
import { useParams } from 'react-router-dom';

import Record from 'ui/Record/Record';

import MainHeader from 'components/MainHeader';

import { useNavBarHeight } from 'utils/hooks/navbar';

import routes from 'core/routes';

import { NotificationCategory, CATEGORY_CONFIG, CATEGORY_LIST } from './constants';
import KnockNotificationsList from './components/KnockNotificationsList';
import KnockNotificationsToolbar from './components/KnockNotificationsToolbar';

const KnockNotifications: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const { category } = useParams<{ category?: string }>();

  const matched = CATEGORY_LIST.find((c) => c === category);
  const activeCategory = matched ?? NotificationCategory.ALL;
  const categoryLabel = CATEGORY_CONFIG[activeCategory].pluralLabel;

  return (
    <Record
      navBarHeight={navBarHeight}
      Content={() => (
        <>
          <KnockNotificationsToolbar />
          <KnockNotificationsList />
        </>
      )}
      Header={
        <MainHeader
          title={activeCategory === NotificationCategory.ALL ? 'Inbox' : categoryLabel}
          breadcrumbs={
            activeCategory === NotificationCategory.ALL
              ? [{ label: 'Inbox', link: String(routes.dashboard.notifications) }]
              : [
                  { label: 'Inbox', link: String(routes.dashboard.notifications) },
                  { label: categoryLabel, link: String(routes.dashboard.notifications) },
                ]
          }
        />
      }
    />
  );
};

export default KnockNotifications;
